import { useQuery } from "@tanstack/react-query";

import { opsAdmin } from "@/api/opsAdmin";
import { Badge, Card, CardBody, EmptyState } from "@/components/ui";

/**
 * Tax documents — all generated tax forms across the org (1099-B / 8949 /
 * MIFID-II KID). Read-only operator view; clients generate/download their own
 * via self-service.
 */
export function AdminTaxDocsPage() {
  const list = useQuery({ queryKey: ["tax-documents"], queryFn: () => opsAdmin.taxDocuments() });

  return (
    <div className="space-y-3">
      <h1 className="text-base font-semibold text-term-fg">Tax documents</h1>
      <Card>
        <CardBody className="p-0">
          {list.isLoading ? (
            <div className="p-3 text-sm text-term-mute">Loading…</div>
          ) : !list.data || list.data.length === 0 ? (
            <EmptyState title="No documents" description="Generated tax documents appear here." />
          ) : (
            <table className="w-full text-xs">
              <thead className="bg-term-elev text-term-mute">
                <tr>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Generated</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Kind</th>
                  <th className="px-3 py-1.5 text-right text-2xs uppercase tracking-wider">Year</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Jurisdiction</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">User</th>
                </tr>
              </thead>
              <tbody>
                {list.data.map((t) => (
                  <tr key={t.id} className="border-t border-term-border hover:bg-term-elev">
                    <td className="px-3 py-1.5 tnum text-term-dim whitespace-nowrap">
                      {t.generated_at ? new Date(t.generated_at).toLocaleString() : "—"}
                    </td>
                    <td className="px-3 py-1.5">
                      <Badge tone="neutral">{t.kind}</Badge>
                    </td>
                    <td className="px-3 py-1.5 text-right tnum text-term-fg">{t.tax_year}</td>
                    <td className="px-3 py-1.5 text-2xs text-term-dim">{t.jurisdiction ?? "—"}</td>
                    <td className="px-3 py-1.5 font-mono text-2xs text-term-dim">
                      {t.user_id ? t.user_id.slice(0, 8) : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
